import React from "react";
import Select from "@components/select";
import { NAME_PREFIX } from "../../../../constants/options";
import { useSetDefaultValue, usePendingPrefill } from "@hooks";

export default function NamePrefix(props) {
  const { name } = props;
  useSetDefaultValue(name);
  usePendingPrefill(name);

  return (
    <>
      <Select
        isPlaceHolder
        placeholder="Select..."
        title="Title"
        options={NAME_PREFIX}
        {...props}
      />
    </>
  );
}
